import { gql } from '@apollo/client';

const ADD_SKILL = gql`
  query skillset {
    skills {
      name
      id
    }
  }
`;
export default ADD_SKILL;
